const PAGE_CONTEXT_JSON_REQUEST_SUFFIX = '/index.pageContext.json';

/**
 * Strips the `/index.pageContext.json` suffix Vike's client-side `navigate()` appends to the
 * request URL when fetching page data without a full reload. `vike-handler.ts` sets
 * `pageContext.urlOriginal` to that raw request URL verbatim — Vike strips the suffix internally
 * for its own routing (`pageContext.urlPathname`/`urlParsed`), but never touches the app-supplied
 * `urlOriginal` field. Any href, redirect target, or `returnTo` built from the raw value bakes
 * "/index.pageContext.json" in as a literal path segment (e.g.
 * "/en/jobs/index.pageContext.json/location/helsinki_finland"), which 404s when a real user hits
 * it. Call this before deriving a pathname from `pageContext.urlOriginal` — or better, prefer
 * `pageContext.urlPathname` directly when a real (non-synthetic) PageContextServer is available,
 * since Vike already strips the suffix there.
 */
export function stripPageContextJsonRequestSuffix(rawUrl: string): string {
  try {
    const parsed = new URL(rawUrl, 'http://localhost');
    if (!parsed.pathname.endsWith(PAGE_CONTEXT_JSON_REQUEST_SUFFIX)) {
      return rawUrl;
    }
    parsed.pathname = parsed.pathname.slice(0, -PAGE_CONTEXT_JSON_REQUEST_SUFFIX.length) || '/';
    return rawUrl.startsWith('http')
      ? parsed.toString()
      : `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return rawUrl;
  }
}
